export const SaveMessagesModes = {
  NONE: 'NONE',
  LAST: 'LAST',
  ALL: 'ALL',
}
